"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSelectorModal = exports.RegionSwitcherSelector = void 0;
var RegionSwitcherSelector_1 = require("./components/RegionSwitcherSelector/RegionSwitcherSelector");
Object.defineProperty(exports, "RegionSwitcherSelector", { enumerable: true, get: function () { return __importDefault(RegionSwitcherSelector_1).default; } });
var RegionSelectorModal_1 = require("./components/RegionSelectorModal/RegionSelectorModal");
Object.defineProperty(exports, "RegionSelectorModal", { enumerable: true, get: function () { return __importDefault(RegionSelectorModal_1).default; } });
//# sourceMappingURL=index.js.map